
import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { BannerSection } from './components/BannerSection';
import { PackagesSection } from './components/PackagesSection';

const ExperiencePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <BannerSection />
        <PackagesSection />
      </main>
      <Footer />
    </div>
  );
};

export default ExperiencePage;
